/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  Stack,
  Link,
  Typography,
  SwipeableDrawer,
  Box,
  Divider,
  Avatar,
} from "@mui/material";

import { toggleNavDrawer } from "../../redux/actions/layout";

import { enToFaDigit, handleWebsiteAddress } from "../../utility/utils";
import styles from "../../styles/layout/navigation.module.scss";

export default function Navigation() {
  let location = useLocation();

  const dispatch = useDispatch();
  const { profile, layout, config } = useSelector((state) => state);
  const isOpen = layout.isNavDrawerOpen;

  const navItems = config.NavigationItems || [];

  const websiteAddress = handleWebsiteAddress();

  const renderNavItems = () => {
    return navItems.map((i, index) => {
      if (i.type === "line") {
        return <Divider key={index} />;
      }

      const text = (
        <Typography
          sx={{
            color:
              location?.pathname === i.path ? "text.first" : "text.primary",
            display: "flex",
            alignItems: "center",
            transition: "all 0.3s",
            margin: "12px 0",

            "&:hover": {
              color: "text.first",
            },
          }}
        >
          <i.icon fontSize="small" sx={{ mr: 1 }} />
          {i.name}
        </Typography>
      );
      return (
        <div key={i.path} onClick={toggleNav}>
          {i.websiteAddress ? (
            <Link href={i.websiteAddress + i.path} target="_blank" key={i.path}>
              {text}
            </Link>
          ) : (
            <Link component={RouterLink} to={i.path} key={i.path}>
              {text}
            </Link>
          )}
        </div>
      );
    });
  };

  const toggleNav = () => dispatch(toggleNavDrawer());

  useEffect(() => {
    if (isOpen) toggleNav();
  }, [location.pathname]);

  return (
    <SwipeableDrawer
      anchor={"left"}
      disableDiscovery={true}
      disableSwipeToOpen={true}
      open={isOpen}
      onClose={toggleNav}
      onOpen={() => {}}
    >
      <Box className={styles.navigation}>
        <Box
          sx={{
            bgcolor: "primary.main",
            p: 2,
            color: "text.secondary",
            width: "100%",
            height: "150px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
            mb={1}
          >
            <Avatar
              src={profile.avatar}
              style={{ width: "60px", height: "60px" }}
            />
            <Link component={RouterLink} to="/">
              <img src={config.PanelLogoWhite} alt="logo" height="30px" />
            </Link>
          </Box>
          <Box>
            <Typography variant="h6" color="#fff">
              {profile?.name || "-"}
            </Typography>
            <Typography variant="subtitle1" color="#fff">
              {enToFaDigit(`${enToFaDigit(profile.mobile || "-")}`)}
            </Typography>
          </Box>
        </Box>

        <Stack sx={{ px: 2 }}>{renderNavItems()}</Stack>
      </Box>
    </SwipeableDrawer>
  );
}
